import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";

export const estimateTermsRatio = (data: {
  numerator: IFaireMoney | undefined;
  denominator: IFaireMoney | undefined;
}): number | undefined => {
  const { numerator, denominator } = data;
  if (
    numerator?.currency === undefined ||
    numerator?.amount_cents === undefined ||
    denominator?.currency === undefined ||
    denominator?.amount_cents === undefined
  ) {
    return;
  }

  if (
    numerator.currency !== denominator.currency ||
    denominator.amount_cents === 0
  ) {
    return;
  }

  return numerator.amount_cents / denominator.amount_cents;
};
